<script>
import { mapActions } from 'vuex';

export default {
  name: 'CompanyListItem',
  props: {
    company: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    ...mapActions('companyList', ['deleteCompany', 'fetchCompanyList']),
    isDeleted() {
      return this.deleteCompany(this.company)
        .then(() => {
          this.fetchCompanyList();
        })
        .catch((error) => {
          console.log(`Fehler: ${error.response}`);
        });
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/company/show/${company.id}`">{{ company.name }}</router-link>
    </td>
    <td>{{ company.street }}</td>
    <td>{{ company.zipCode }}</td>
    <td>{{ company.city }}</td>
    <td>
      <v-icon v-if="company.isActive">done</v-icon>
      <v-icon v-else>close</v-icon>
    </td>
    <!--<td>
      <v-icon v-if="company.isDelete">done</v-icon>
      <v-icon v-else>close</v-icon>
    </td>
    <td width="160" align="right">
      <v-tooltip bottom>
        <v-btn flat icon disabled slot="activator">
          <v-icon small>not_interested</v-icon>
        </v-btn>
        <span>Deaktivieren</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn @click.native="isDeleted" flat icon slot="activator">
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>-->
  </tr>
</template>
